// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__3jhGx","content":"styles_content__2ijBN","checkbox":"styles_checkbox__2hwg0","checkboxLabel":"styles_checkboxLabel__1pqtU"};